import { FunctionComponent, useMemo } from 'react';
import Image from 'next/image';
import styles from './styles.module.scss';
import { ImageCarousel } from '../../../components/ImageCarousel';
import { PublicCourse } from '@cademy-package/sdk-component-types';

export type ImagesSectionProps = {
    course: PublicCourse;
};

export const ImagesSection: FunctionComponent<ImagesSectionProps> = ({ course }) => {
    const images = useMemo(() => {
        if (!course.img_urls || course.img_urls.length === 0) {
            return [];
        }
        return course.img_urls.map((imageURL, index) => {
            return {
                url: imageURL,
                alt: course.name,
                priority: index === 0,
            };
        });
    }, [course]);
    return (
        <section className={styles.course_image_section} aria-labelledby="course-images-header">
            <h2 id="course-images-header" className="screen_reader_hidden">
                Course Images
            </h2>
            {course.img_urls && course.img_urls.length > 1 ? (
                <ImageCarousel
                    name="Images"
                    classNames={{ container: styles.imageCarouselContainer }}
                    images={images}
                />
            ) : null}
            {course.img_urls && course.img_urls.length === 1 ? (
                <div className={styles.course_image}>
                    <Image
                        tabIndex={0}
                        src={course.img_urls[0]}
                        alt={course.name}
                        fill
                        priority={true}
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                    <div
                        className={styles.blurred_background_image}
                        style={{ backgroundImage: `url(${course.img_urls[0]})` }}
                    ></div>
                </div>
            ) : null}
            {(!course.img_urls || course.img_urls.length === 0) && course.autoimg ? (
                <>
                    <div className={styles.course_image}>
                        <Image
                            tabIndex={0}
                            src={course.autoimg.url}
                            alt={course.name}
                            fill
                            priority={true}
                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        />
                        <div
                            className={styles.blurred_background_image}
                            style={{ backgroundImage: `url(${course.autoimg.url})` }}
                        ></div>
                    </div>
                    <span className={styles.unsplash_notice}>
                        Please note, this image was automatically generated based on the course
                        title and may not reflect the actual experience. Stock photo by{' '}
                        {course.autoimg.author} on Unsplash.
                    </span>
                </>
            ) : null}
        </section>
    );
};

export default ImagesSection;
